module.exports = __webpack_public_path__ + "static/media/mobile-promos-banner_3.4b03e8d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promos-banner/mobile-promos-banner_3.jpg
// module id = 2451
// module chunks = 7